import $ from "jquery";

$(function () {
  if (location.pathname.split("/")[1] == "") {
    $(".nav li").removeClass("active");
    $(".nav .inicio").addClass("active");
  } else if (location.pathname.split("/")[1] == "jugos") {
    $(".nav li").removeClass("active");
    $(".nav .jugos").addClass("active");
  } else if (location.pathname.split("/")[1] == "nosotros") {
    $(".nav li").removeClass("active");
    $(".nav .nosotros").addClass("active");
  }

  $(document)
    .on("show.bs.collapse", "#website #main-nav .navbar-collapse", function () {
      $("#website #main-nav").addClass("expanded");
    })
    .on("hide.bs.collapse", "#website #main-nav .navbar-collapse", function () {
      $("#website #main-nav").removeClass("expanded");
    });

  $(".navbar-nav li a").on("click", function (event) {
    // check if window is small enough so dropdown is created
    var toggle = $(".navbar-toggle").is(":visible");
    if (toggle) {
      $(".navbar-collapse").collapse("hide");
    }
  });
});
